"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ENABLED_FOOTER_INPUT_TYPES = exports.useFooterValue = void 0;
var core_money_1 = require("@newfront-insurance/core-money");
var dsl_schema_api_1 = require("@newfront-insurance/dsl-schema-api");
var get_1 = __importDefault(require("lodash/get"));
var react_1 = require("react");
function useFooterValue(rows, accessor, inputType, footerType) {
    return (0, react_1.useMemo)(function () {
        if (!footerType) {
            return '';
        }
        if (inputType === dsl_schema_api_1.InputType.CURRENCY) {
            return calculateMoney(rows, accessor, footerType);
        }
        if (inputType === dsl_schema_api_1.InputType.NUMBER) {
            return calculateNumber(rows, accessor, footerType);
        }
        return '';
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [rows]);
}
exports.useFooterValue = useFooterValue;
function calculateMoney(rows, accessor, footerType) {
    var totalUnits = rows.reduce(function (sum, row) {
        var money = (0, get_1.default)(row.original, accessor);
        return sum + ((money === null || money === void 0 ? void 0 : money.units) || 0);
    }, 0);
    var totalNanos = rows.reduce(function (sum, row) {
        var money = (0, get_1.default)(row.original, accessor);
        return sum + ((money === null || money === void 0 ? void 0 : money.nanos) || 0);
    }, 0);
    if (footerType === dsl_schema_api_1.SpreadsheetFooterType.AVERAGE) {
        totalUnits = Math.round(totalUnits / rows.length);
        totalNanos = Math.round(totalUnits / rows.length);
    }
    return (0, core_money_1.moneyToString)({
        // hardcoding to USD for now as we don't have other currencies supported
        currencyCode: core_money_1.CurrencyCode.USD,
        units: totalUnits,
        nanos: totalNanos,
    });
}
function calculateNumber(rows, accessor, footerType) {
    var total = rows.reduce(function (sum, row) {
        var number = (0, get_1.default)(row.values, accessor);
        return sum + (Number(number) || 0);
    }, 0);
    if (footerType === dsl_schema_api_1.SpreadsheetFooterType.AVERAGE) {
        total = Math.round(total / rows.length);
    }
    return total;
}
exports.ENABLED_FOOTER_INPUT_TYPES = [dsl_schema_api_1.InputType.CURRENCY, dsl_schema_api_1.InputType.NUMBER];
